import React, { useContext, useEffect, useRef } from 'react'
import { DAGTask } from '@pollination-solutions/pollination-sdk'
import { FlowOutputNode } from './FlowOutputNode'
import { RootContext as context } from '~/state'
import { DAGOutput } from '~/types/queenbee/io'

interface FlowOutputsProps {
  position: [number, number]
  size: [number, number]
  outputs: DAGOutput[]
  tasks: DAGTask[]
}

export const FlowOutputs = ({ position, size, outputs, tasks }: FlowOutputsProps): JSX.Element => {
  const [x, y] = position
  const [w, h] = size

  const { graph, layout, registerExtent } = useContext(context)
  const [dx, dy] = layout?.position ?? [0, 0]
  const z = layout?.zoom ?? 1

  const outputsRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (layout?.right) {
      return
    }

    registerExtent(outputsRef, 'right')
  }, [layout, registerExtent])

  const isFaded = (graph?.highlight?.length ?? 0 > 0) && !graph?.highlight.some((key) => key.includes('output'))

  return (
    <div
      className={`outputs ${isFaded ? 'outputs--faded' : ''}`}
      style={{
        position: 'absolute',
        left: (x + dx + 50 + w / 2) * z,
        top: (y + dy - h / 2) * z,
        minHeight: h,
        transform: `scale(${z})`,
      }}
      ref={outputsRef}
    >
      {outputs.map((output) => (
        <FlowOutputNode key={output.name} output={output} tasks={tasks} />
      ))}
      <style jsx>{`
        .outputs {
          width: 15px;
          box-sizing: content-box;
          padding-top: 12px;
          padding-bottom: 12px;
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
          border: 2px solid #333;
          border-left: none;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          transition: border;
          transition-duration: 300ms;
        }

        .outputs--faded {
          border: 2px solid #dadada;
          border-left: none;
        }
      `}</style>
    </div>
  )
}
